import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledImage = styled('img')({
  height: '120px',
  width: 'auto',
  objectFit: 'contain',
});

interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Logo: React.FC<LogoProps> = ({ className, style }) => {
  return (
    <StyledImage
      src="/assets/logo.png"
      alt="A Wise Friend"
      className={className}
      style={style}
    />
  );
}; 